import { render, staticRenderFns } from "./TablePKSetting.vue?vue&type=template&id=170c7710&"
import script from "./TablePKSetting.vue?vue&type=script&lang=js&"
export * from "./TablePKSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports